<template>
  <div style="height: 250px; margin-top: 24px">
    <canvas ref="canvas" height="250px" width="882px"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js';
import { chartOptions } from '@/utils/chartOptions';

export default {
  name: 'chart',
  props: {
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ctx: null,
    };
  },
  watch: {
    chartData() {
      if(this.ctx) {
        this.ctx.destroy();
      }
      this.renderChart();
    },
  },
  mounted() {
    this.renderChart();
  },
  methods: {
    renderChart() {
      this.ctx = new Chart(this.$refs.canvas.getContext('2d'), {
        type: 'bar',
        data: {
          labels: this.chartData?.map((item) => item.date),
          datasets: [
            {
              data: this.chartData?.map((item) => item.orderCount),
              backgroundColor: '#F4E',
              hoverBackgroundColor: '#661B5F',
              borderColor: '#F4E',
              borderWidth: 0,
              label: 'Sipariş Sayısı',
            },
          ],
        },
        options: {
          ...chartOptions.options,
        },
      });
    },
  },
};
</script>
